import { ReajusteFuncaoLinha } from '../simulador-folha.types';
import { formatarMoeda } from '@/shared/utils/numeros';

interface Props {
  linhas: ReajusteFuncaoLinha[];
  onChange: (funcaoId: number, campo: 'tipoReajuste' | 'valorReajuste', valor: string) => void;
}

export function TabelaReajustesFuncao({ linhas, onChange }: Props) {
  const totalSalarioVigente = linhas.reduce(
    (acc, linha) => acc + (linha.ultimoSalarioVigente ?? 0),
    0,
  );
  const funcoesComSalario = linhas.filter((l) => l.ultimoSalarioVigente != null).length;

  return (
    <div className="table-responsive">
      <table className="table table-sm table-bordered table-striped align-middle">
        <thead>
          <tr>
            <th>Função</th>
            <th className="text-end">Salário vigente</th>
            <th style={{ width: 180 }}>Tipo de reajuste</th>
            <th style={{ width: 160 }}>Valor do reajuste</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((linha) => (
            <tr key={linha.funcaoId}>
              <td>{linha.funcaoNome}</td>
              <td className="text-end">
                {linha.ultimoSalarioVigente != null
                  ? formatarMoeda(linha.ultimoSalarioVigente)
                  : <span className="text-muted">—</span>}
              </td>
              <td>
                <select
                  className="form-select form-select-sm"
                  value={linha.tipoReajuste}
                  onChange={(e) => onChange(linha.funcaoId, 'tipoReajuste', e.target.value)}
                >
                  <option value="PERCENTUAL">Percentual (%)</option>
                  <option value="VALOR_FIXO">Valor fixo (R$)</option>
                </select>
              </td>
              <td>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  className="form-control form-control-sm"
                  value={linha.valorReajuste}
                  onChange={(e) => onChange(linha.funcaoId, 'valorReajuste', e.target.value)}
                />
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="table-secondary fw-semibold">
          <tr>
            <td>Total ({funcoesComSalario === 1 ? '1 função' : `${funcoesComSalario} funções`} com salário)</td>
            <td className="text-end">
              {funcoesComSalario > 0 ? formatarMoeda(totalSalarioVigente) : <span className="text-muted">—</span>}
            </td>
            <td colSpan={2} />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export function formatarReajusteLinha(linha: Pick<ReajusteFuncaoLinha, 'tipoReajuste' | 'valorReajuste'>): string {
  if (linha.tipoReajuste === 'PERCENTUAL') {
    return `${linha.valorReajuste}%`;
  }
  return formatarMoeda(linha.valorReajuste);
}
